'use client';

import { useEffect } from 'react';

// ----------------------------------------------------------------------

/**
 * Globalt kortkommando: Cmd+Enter (Ctrl+Enter på Windows/Linux) skickar det
 * formulär som fokus befinner sig i.
 *
 * Fungerar för varje <form> på sidan — både `Form`-wrappern i
 * `src/components/hook-form` och dialoger vars Paper renderas som
 * `component: 'form'`. Dialoger utan formulärelement påverkas inte.
 */
export function SkickaFormulärGenväg() {
  useEffect(() => {
    function vidTangentnedslag(event: KeyboardEvent) {
      if (event.key !== 'Enter' || !(event.metaKey || event.ctrlKey)) return;
      if (event.isComposing) return;
      // En närmare komponent har redan hanterat kommandot.
      if (event.defaultPrevented) return;

      const formulär = (event.target as HTMLElement | null)?.closest?.('form');
      if (!formulär) return;

      event.preventDefault();
      // requestSubmit — inte submit — kör HTML-valideringen och utlöser
      // onSubmit, vilket är det react-hook-form och våra dialoger lyssnar på.
      formulär.requestSubmit();
    }

    document.addEventListener('keydown', vidTangentnedslag);
    return () => document.removeEventListener('keydown', vidTangentnedslag);
  }, []);

  return null;
}
